
/**
 * @imports
 */
import { Observer } from './index.js';

// As globals
if (!window.webqit) { window.webqit = {}; }
window.webqit.Observer = Observer;